import configureStore, { history } from "./configureStore";
import initialState from './initialState';

const {store, persistor} = configureStore(initialState);

export {store, persistor, history};